// extracted by mini-css-extract-plugin
module.exports = {"button":"button-3NiXP","white":"white-1zRna"};